module.exports = __webpack_public_path__ + "img/hipnose.6620a48d.png";